import { captureMiddlewareError } from './captureMiddlewareError'
import { createApiResponseError } from '../default/ApiResponseError'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Submits form
 * @param {SubmitBody} payload - The payload
 * @returns {Promise<FormSubmitResponse>}
 */
export async function formSubmit(payload) {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/form-submit'
  const url = `${apiBase}${endpoint}`

  try {
    const body = JSON.stringify(payload)
    const response = await fetch(url, {
      body,
      headers: getMiddlewareHeaders(),
      method: 'POST',
    })

    if (response.ok) {
      const data = await response.json()
      return data || {}
    }

    throw await createApiResponseError(response, endpoint)
  } catch (error) {
    captureMiddlewareError(url, /** @type {Error} */ (error))
    return {}
  }
}
